module.exports = {
    INPUT_TIME_PLACEHOLDER: '__:__h'
};
